<template>
    <div class="description full flex wrap center">
        <h4>اگر پیامک تأیید دریافت نکردید:</h4>
        <span>
            {{ description }}
        </span>
        <h5>این روش امن، سریع و فقط مخصوص تأیید شماره شماست.</h5>
    </div>
    <div class="full flex wrap center">
        <div class="full ssi flex wrap center vcenter">
            <button @click="$emit('onresult')">
                <a :href="data?.uri">احرازهویت خودکار</a>
            </button>
        </div>
        <div class="full spam flex wrap center vcenter">
            <button @click="$emit('onresult')">
                <a :href="'sms:+989890006304?body='">مشاهده پوشه اسپم</a>
            </button>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'SSI',
    props: ['data'],
    inject: ['base'],
    components: {},
    data() {
        return {
            description: `
1. با زدن دکمه «احراز هویت خودکار»، یک پیام آماده برایتان باز می‌شود.

2. کافی‌ست آن را بدون تغییر برای ما ارسال کنید.

3. سیستم به‌صورت خودکار پیام را بررسی کرده و شما را وارد می‌کند.`
        }
    },
    methods: {
        download(format) {
            this.$emit('onloading', true)
            this.base.API().postAsArrayBuffer(`Data/Report/${format}`, {
                data: Object.assign(Object.assign(this.$route.query, {
                    entity_type: this.data?.entity_type.toUpperCase(),
                    search: this.data?.search
                }), this.data?.query)
            }, (response) => {
                this.$emit('onloading', false)
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(new Blob([response.data]))
                link.setAttribute('download', `report-${Date.now()}.${format === 'ReportAsExcel' ? 'xlsx' : 'pdf'}`)
                document.body.appendChild(link)
                link.click()

                this.$emit('onresult')
            }, (error) => {
                this.$emit('onloading', false)
            })
        }
    }
}
</script>

<style scoped src="../../assets/css/components/dialogs/ssi.css"></style>